import React from "react";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";
import CorporateSidebar from "../components/Corporate/CorporateSidebar";

const CorporateQualityPolicy = () => {
  return (
    <>
     <div>
      <HeroSlider />
      <div className="bg-white text-black py-8 px-4 max-w-screen-xl mx-auto">
        {/* <div className="text-sm text-gray-600 mb-4">
          <span className="underline">ana sayfa</span> &nbsp;>&nbsp;
          <span className="underline">kurumsal</span> &nbsp;>&nbsp;
          <span>Kalite Politikamız</span>
        </div> */}

        <div className="text-xl font-semibold text-[#003132] mb-6">KURUMSAL MENÜ</div>

        <div className="flex flex-col md:flex-row gap-10">
          <CorporateSidebar />
          <div className="flex-1">
            <h2 className="text-2xl font-bold mb-4 text-[#003132]">Kalite Polittikamız</h2>
             <p className="text-gray-700 leading-7">
          Firmamız, müşteri memnuniyetini en üst seviyeye çıkarmak ve sürekli iyileştirme sağlamak adına yüksek kalite standartlarını benimsemektedir. 
          Ürün ve hizmetlerimizi mükemmelleştirmek için güçlü bir kalite yönetim sistemi oluşturduk.
        </p>

        <p className="text-gray-700 leading-7 mt-4">
          Çalışanlarımızın gelişimini destekleyerek, sürdürülebilir kalite anlayışımızı tüm süreçlerimize entegre ediyoruz.
        </p>

        {/* Alt görsel ya da ek bilgiler */}
        <div className="mt-6 p-4 bg-gray-100 rounded">
          <h2 className="text-xl font-semibold text-[#003132]">Temel Kalite İlkelerimiz</h2>
          <ul className="list-disc pl-5 text-gray-700 mt-2">
            <li>Müşteri odaklı hizmet anlayışı</li>
            <li>ISO 9001 kalite yönetim standartlarına bağlılık</li>
            <li>Sürekli iyileştirme ve çalışan eğitimi</li>
            <li>Çevreye duyarlı üretim süreçleri</li>
          </ul>
        </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    </>
  );
};

export default CorporateQualityPolicy;
